import {
    CUSTOMER_ORDER
} from "../../constants/actionTypes";

const INIT_STATE = {
    isLoading: false,
    alertMessage: '',
    messageId: null,
    lists: []
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CUSTOMER_ORDER.CUSTOMER_ORDER_RESET: {
            return {
                ...state,
                isLoading: false,
                alertMessage: '',
                messageId: null
            }
        }

        case CUSTOMER_ORDER.LIST_CUSTOMER_ORDER_REQUEST: {
            return {
                ...state,
                isLoading: true
            }
        }

        case CUSTOMER_ORDER.LIST_CUSTOMER_ORDER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                messageId: 200,
                lists: action.payload
            }
        }

        case CUSTOMER_ORDER.LIST_CUSTOMER_ORDER_FAIL: {
            return {
                ...state,
                isLoading: false,
                alertMessage: action.payload.message,
                messageId: 203
            }
        }

        case CUSTOMER_ORDER.SEARCH_CUSTOMER_ORDER_REQUEST: {
            return {
              ...state,
              loader: true
            }
          }
      
          case CUSTOMER_ORDER.SEARCH_CUSTOMER_ORDER_SUCCESS: {
            return {
              ...state,
              loader: false,
              messageId: 200,
              lists: action.payload
            }
          }
      
          case CUSTOMER_ORDER.SEARCH_CUSTOMER_ORDER_FAIL: {
            return {
              ...state,
              loader: false,
              alertMessage: action.payload.message,
              messageId: 203
            }
          }

        default:
            return state;
    }
}
